module.exports = __webpack_public_path__ + "static/media/08_twitter_image.0b08468d.jpg";